// extracted by mini-css-extract-plugin
export default {"constructionContainer":"OnlineMenu_constructionContainer__IFxCX","constructionImg":"OnlineMenu_constructionImg__hr5C1","linkToHome":"OnlineMenu_linkToHome__UnXzj"};